import { render, staticRenderFns } from "./BotaoInteligenciaCarbono.vue?vue&type=template&id=621d5a9f&lang=pug"
import script from "./BotaoInteligenciaCarbono.vue?vue&type=script&lang=js"
export * from "./BotaoInteligenciaCarbono.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports